import { SortDescriptor } from '@progress/kendo-data-query';
import * as Redux from 'redux'
import * as Request from '../../request'
import * as Utils from './utils'

export type SortAction = Request.RequestAction<{value: SortDescriptor[]}>
export interface SimpleSortAction extends Redux.Action {sort: SortDescriptor[]}
export const changeSort = (prefix: string) => (e: any) => ({type: Utils.sortTableConstant(prefix), sort: e.sort})



// WEBPACK FOOTER //
// ./src/components/sortable/actions.ts